export const driverValueGetter = ({ data: { driverName, driverNumber } }) => {
  return `${driverName} ${driverNumber ? '(' + driverNumber + ')' : ''}`;
};
